import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    CurrentAttachmentVersionDto,
    Lotam,
    NoticeDto,
    Organisation
} from '@flyfreely-portal-ui/flyfreely';
import { FeatureCollection } from 'geojson';
import { getFeatureGroups } from 'libs/locations/src/lib/helpers';
import { FeatureGroup } from 'libs/map/src/lib/index';
import {
    formatLotamAudience,
    formatLotamPriority,
    formatOperatingRequirement
} from 'libs/notices/src/lib/lotam-data.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
    selector: 'lotam-details',
    templateUrl: './lotam-details.component.html',
    styleUrls: ['./lotam-details.component.scss']
})
export class LotamDetailsComponent implements OnInit, OnDestroy {
    downloadUrlFn = (attachment: CurrentAttachmentVersionDto) => {
        return `/webapi/notices/${this.lotam.id}/attachments`;
    };
    @Input() lotam: Lotam;
    @Input() organisation: Organisation;

    locationFeatures: FeatureGroup[];
    mapData$ = new BehaviorSubject<{ [source: string]: FeatureCollection }>({});

    private ngUnsubscribe$ = new Subject<void>();

    constructor(private modal: BsModalRef<LotamDetailsComponent>) {}

    ngOnInit(): void {
        this.locationFeatures = this.lotam.location
            ? getFeatureGroups(this.lotam.location, 1, 1).features
            : [];
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    protected readonly formatLotamPriority = formatLotamPriority;
    protected readonly formatAudience = formatLotamAudience;
    protected readonly formatOperatingRequirement = formatOperatingRequirement;

    get hasLocation() {
        return (
            this.lotam && this.lotam.location && this.lotam.location.length > 0
        );
    }

    cancel() {
        this.modal.hide();
    }

    protected readonly NoticeDto = NoticeDto;
}
